import type { PaywallGate } from '@parcel/analytics';
import { capture } from '@parcel/analytics/browser';
import type { Plan } from '@parcel/types';
import { Button } from '@parcel/ui';
import { Link } from '@tanstack/react-router';
import type * as React from 'react';
import { useEntitlements } from '../../lib/entitlements.js';

export function planLabel(plan: Plan): string {
  return plan === 'pro' ? 'Pro' : plan === 'starter' ? 'Starter' : 'Free';
}

export function UpgradeButton({
  workspaceSlug,
  gate,
  size = 'sm',
  children,
}: {
  workspaceSlug: string;
  /** Which paywall rendered this button, so upgrade_clicked is attributable. */
  gate: PaywallGate;
  size?: 'sm' | 'default' | 'lg';
  children?: React.ReactNode;
}) {
  // Resolved here rather than threaded: the slug is already a prop, and
  // useEntitlements is a cache hit on the ['workspace', slug] bootstrap query.
  const { effectivePlan } = useEntitlements(workspaceSlug);
  const billingPath: string = `/${encodeURIComponent(workspaceSlug)}/settings/billing`;
  return (
    <Button asChild variant="default" size={size}>
      <Link
        to={billingPath}
        onClick={() => capture('upgrade_clicked', { gate, current_plan: effectivePlan })}
      >
        {children ?? 'Upgrade'}
      </Link>
    </Button>
  );
}
